import { c } from "./colors";
import { Frame, type IllustrationProps } from "./Frame";

// Four-fold symmetric, purely decorative: not a scannable code.
const CORNERS = [
  [46, 46],
  [94, 46],
  [46, 94],
  [94, 94],
] as const;
const MODULES = [
  [70, 50],
  [84, 50],
  [77, 60],
  [70, 104],
  [84, 104],
  [77, 94],
  [50, 70],
  [50, 84],
  [60, 77],
  [104, 70],
  [104, 84],
  [94, 77],
] as const;

export function QrIllustration(props: IllustrationProps) {
  return (
    <Frame {...props}>
      <rect
        x="36"
        y="36"
        width="88"
        height="88"
        rx="12"
        fill={c.n0}
        stroke={c.p200}
        strokeWidth="2"
      />
      {CORNERS.map(([x, y]) => (
        <g key={`${x}-${y}`}>
          <rect x={x} y={y} width="20" height="20" rx="4" fill={c.p600} />
          <rect x={x + 4} y={y + 4} width="12" height="12" rx="2" fill={c.n0} />
          <rect x={x + 7} y={y + 7} width="6" height="6" rx="1.5" fill={c.p600} />
        </g>
      ))}
      {MODULES.map(([x, y]) => (
        <rect key={`${x}-${y}`} x={x} y={y} width="6" height="6" rx="1.5" fill={c.p400} />
      ))}
      <rect x="77" y="77" width="6" height="6" rx="1.5" fill={c.a400} />
    </Frame>
  );
}
